class DebtCalculator {
  constructor(debtCalculator, modalId, backdrop ) {
    this.debtCalculator = document.getElementById(debtCalculator);
    this.modaldiv = document.getElementById(modalId);
    this.backdrop = document.getElementById(backdrop);
    this.errorMsg;
    this.calIndex = 0;
    this.calLoans = [];
    this.TotalOutstandingBalance = 0;
    this.TotalCurrentMonthlyPayment = 0;
    this.calProfitADIB = 0.0399;
    this.calProfitOthers = 0.0499;
    this.calTenure = 4; // years
    this.mPaymentADIB = null;
    this.mPaymentDiff = null;
    this.monthlyDiff = 0;
    this.postObj = {};
    this.isIE7 = false;
    this.bversion = 10;
    this.str = "";
    this.myChart = null;
    this.chartFlag = 0;
    this.pathname = null;
    this.btnEnabled = true;
    this.MsgMoreDebts = "Sorry!, you cannot add more than 5 debts";
    this.MsgMonthlyDebt = "Please select monthly payment for your debt";
    this.MsgOutStandingBalance =
      "Please select outstanding balance for your debt";
    this.MsgAddOneDebt = "Please add at least one debt";
    this.MsgdebtNotAdded =
      "The last debt you select is not added to you debts list. Do you want to discard it and continue?";
    this.MsgSelectType = "Please select a debt type";
    this.eleDivResult;
    this.init();
  }
  init() {
    document.addEventListener('DOMContentLoaded',()=>{
      if (this.debtCalculator) {
        this.bindEvents();
      }
    })
  }

  bindEvents() {
    this.MsgMoreDebts = this.debtCalculator.getAttribute("data-msgmoredebts");
    this.MsgMonthlyDebt = this.debtCalculator.getAttribute(
      "data-msgmonthlydebt"
    );
    this.MsgOutStandingBalance = this.debtCalculator.getAttribute(
      "data-msgoutstandingbalance"
    );
    this.MsgAddOneDebt = this.debtCalculator.getAttribute("data-msgaddonedebt");
    this.MsgdebtNotAdded = this.debtCalculator.getAttribute(
      "data-msgdebtnotadded"
    );
    this.MsgSelectType = this.debtCalculator.getAttribute("data-msgselecttype");
    this.eleDivResult = $(this.debtCalculator).find("#DivResult");
    this.eleDivResult.hide();
    $(this.debtCalculator).find("#DivDebitCouts").hide();
    this.errorMsg = $(this.debtCalculator).find("#errorMsg");
    
    this.initSliders();
    this.initKeyPressEvents();
    this.initKeyUpEvents();

    $(this.debtCalculator)
      .find("#btnAddAnotherDebt")
      .click(this.handleAddAnotherDebtClick);
    $(this.debtCalculator)
      .find("#btnConsolidate")
      .click(this.handleConsolidateClick);
    $(this.debtCalculator).find("#btnReset").click(this.handleResetClick);
    $(this.debtCalculator)
      .find("#btnConsolidate")
      .click(this.handleConsolidateClick);
    $(this.debtCalculator)
      .find("#applyForAlKharSettlement")
      .click(this.handleAlKhairSettlement);

      this.modaldiv
      .querySelector("#closeForm")
      .addEventListener("click", () => this.closeModal());
  }
  
  closeModal() {
    this.modaldiv.classList.remove('open');
    this.backdrop.classList.remove('open');
    $(this.eleDivResult).show();
    $(this.debtCalculator).find("#DivDebitCouts").show();
  }

  numberWithCommas(n) {
    var parts = n.toString().split(".");
    return (
      parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
      (parts[1] ? "." + parts[1] : "")
    );
  } /// fun. numberWithCommas


  initSliders() {
    let sliderMax = parseInt(
      $(this.debtCalculator)
        .find("#SliderOustandingBalance")
        .attr("data-slider-max")
    );
    let sliderMin = parseInt(
      $(this.debtCalculator)
        .find("#SliderOustandingBalance")
        .attr("data-slider-min")
    );

    let value = parseInt(
      $(this.debtCalculator).find("#balance").attr("data-slider-initialvalue")
    );
    let checkLang = document.querySelector("html").getAttribute('lang');
    $(this.debtCalculator)
      .find("#SliderOustandingBalance")
      .slider({
        range: "min",
        value: value || 0,
        min: sliderMin || 0,
        max: sliderMax || 3000000,
        isRTL: checkLang === 'ar' ? true : false,
        slide: (e, ui) => {
          $(this.debtCalculator).find("#balance").val(this.numberWithCommas(ui.value));
        },
      });

    let sliderDownPaymentMax = parseInt(
      $(this.debtCalculator).find("#sliderDownPayment").attr("data-slider-max")
    );
    let sliderDownPaymentMin = parseInt(
      $(this.debtCalculator).find("#sliderDownPayment").attr("data-slider-min")
    );
    let sliderDownPaymentValue = parseInt(
      $(this.debtCalculator).find("#monthly").attr("data-slider-initialvalue")
    );

    $(this.debtCalculator)
      .find("#sliderDownPayment")
      .slider({
        range: "min",
        value: sliderDownPaymentValue || 0,
        min: sliderDownPaymentMin || 0,
        max: sliderDownPaymentMax || 100000,
        isRTL: checkLang === 'ar' ? true : false,
        slide: (e, ui) => {
          $(this.debtCalculator).find("#monthly").val(this.numberWithCommas(ui.value));
        },
      });
  }

  initKeyPressEvents() {
    $(this.debtCalculator)
      .find("#balance")
      .keypress((e) => {
        var charCode = e.which ? e.which : event.keyCode;
        if (String.fromCharCode(charCode).match(/[^0-9]/g)) return false;
      });

    $(this.debtCalculator)
      .find("#monthly")
      .keypress((e) => {
        var charCode = e.which ? e.which : event.keyCode;
        if (String.fromCharCode(charCode).match(/[^0-9]/g)) return false;
      });
  }

  initKeyUpEvents() {
    $(this.debtCalculator)
      .find("#balance")
      .keyup("input", () => {
        $(this.debtCalculator)
          .find("#SliderOustandingBalance")
          .slider("value", $(this.debtCalculator).find("#balance").val());
      });

    $(this.debtCalculator)
      .find("#monthly")
      .keyup("input", () => {
        $(this.debtCalculator)
          .find("#sliderDownPayment")
          .slider("value", $(this.debtCalculator).find("#monthly").val());
      });
  }

  handleAddAnotherDebtClick = () => {
    $(this.errorMsg).hide();
    $(this.debtCalculator).find("#DivDebitCouts").show();

    var error = "";

    if (this.calLoans.length >= 5) {
      $(this.debtCalculator).find("#ddlLoanType")[0].selectedIndex = 0;
      $(this.debtCalculator)
        .find("#SliderOustandingBalance")
        .slider("value", 0);
      $(this.debtCalculator).find("#sliderDownPayment").slider("value", 0);
      $(this.debtCalculator).find("#monthly").val("0");
      $(this.debtCalculator).find("#balance").val("0");
      // alert(this.MsgMoreDebts);
      errorMsg.innerHTML = MsgMoreDebts;
      errorMsg.style.color = "red";
      return false;
    }
    

    var type = $(this.debtCalculator).find("#ddlLoanType").val();
    var balance = $(this.debtCalculator)
      .find("#SliderOustandingBalance")
      .slider("value");
    var monthly = $(this.debtCalculator)
      .find("#sliderDownPayment")
      .slider("value");

    if (!type) {
      error += this.MsgSelectType + "\n";
    }

    if (balance == 0) {
      error += this.MsgOutStandingBalance + "\n";
    }

    if (monthly == 0) {
      error += this.MsgMonthlyDebt + "\n";
    }

    if (error != "") {
      console.log(error, "errrrr");
      errorMsg.innerHTML = error;
      errorMsg.style.color = "red";
    $(this.errorMsg).show();

    } else {
      // add a row
      this.calLoans.push({
        id: this.calIndex,
        type: type,
        balance: balance,
        monthly: monthly,
      });

      var rowID = "row_" + this.calIndex;

      this.str +=
        '<div class="row mb-1 lh-1" style="background-color: #f4f4f4; font-size: 0.9rem;" id="' +
        rowID +
        '"	>';
      this.str +=
        '<div class="col-md-3 col-3 text-center text-dark p-2 text-space-5">' +
        type +
        "</div>";
      this.str +=
        '<div class="col-md-3 col-3 text-center text-dark p-2 text-space-5">' +
        this.numberWithCommas(balance) +
        "</div>";
      this.str +=
        '<div class="col-md-3 col-3 text-center text-dark p-2 text-space-5">' +
        this.numberWithCommas(monthly) +
        "</div>";
      this.str +=
        '<div class="col-md-3 col-3 text-center text-dark p-2 text-space-5"><i class="icon-close" style=" cursor: pointer;" data-calIndex="' +
        this.calIndex +
        '"></i></div>';
      this.str += "</div>";
      $("#calRows").append(this.str);
      this.str = "";
      $("#lbDebitCount").text(this.calLoans.length);

      $("#" + rowID).slideDown();

      ++this.calIndex;

      /// reset the calc
      $("#balance").val("0");
      $("#monthly").val("0");
      $("#SliderOustandingBalance").slider("value", "0");
      $("#sliderDownPayment").slider("value", "0");
      $("#ddlLoanType")[0].selectedIndex = 0;

      let clickableRows = document.querySelectorAll('.icon-close');
      clickableRows.forEach(row => {
          row.addEventListener('click', this.removeRow.bind(this,row));
      });
      /// update total
      // updateTotal();
    }
  }; /////////// debtInsert click

  handleConsolidateClick = () => {
    if (this.calLoans.length <= 0) {
      alert(this.MsgAddOneDebt);
    } else {
      //// check if user has changed any of the debt values
      if (
        $("#SliderOustandingBalance").slider("value") > 0 ||
        $("#sliderDownPayment").slider("value") > 0
      ) {
        //  ||
        var ss = confirm(MsgdebtNotAdded);
        this.updateTotal();
        $("#retirement-planner-result").style.display = 'block'
      } else {
        this.updateTotal();
      }

      //  _gaq.push(['_trackPageview', '/en/debt-consolidator/step2/']);
    }
  };

  resetform = () => {
    $("#DivResult").hide();
    $("#DivDebitCouts").hide();
    $("#errorMsg").hide();

    $("#calRows").empty();
    $("#SliderOustandingBalance").slider("value", "0");
    $("#sliderDownPayment").slider("value", "0");
    $("#monthly").val("0");
    $("#balance").val("0");
    this.calLoans = new Array();
  };
  handleResetClick = () => {
    this.resetform();
    // console.log('reset');
  };

  updateTotal() {
    $("#DivResult").show();

    this.TotalOutstandingBalance = 0;
    this.TotalCurrentMonthlyPayment = 0;
    /// below vars for building string for back end saving
    let strAllT = "";
    let strAllB = "";
    let strAllM = "";

    for (var j = 0; j < this.calLoans.length; ++j) {
      this.TotalOutstandingBalance += this.calLoans[j].balance;
      this.TotalCurrentMonthlyPayment += this.calLoans[j].monthly;

      strAllT += this.calLoans[j].type + "|";
      strAllB += String(this.calLoans[j].balance) + "|";
      strAllM += String(this.calLoans[j].monthly) + "|";

      ////////// update the row number in html
      $("#row_" + this.calLoans[j].id + " .added_info_counter").html(
        String(j + 1)
      );
    }

    //////// remove the last separator for string
    strAllT = strAllT.substring(0, strAllT.length - 1);
    strAllB = strAllB.substring(0, strAllB.length - 1);
    strAllM = strAllM.substring(0, strAllM.length - 1);

    $("#lbTotalOutstandingBalance").html(this.numberWithCommas(this.TotalOutstandingBalance));
    $("#lbTotalCurrentMonthlyPayment").html(this.numberWithCommas(this.TotalCurrentMonthlyPayment));

    /////////// do calucations
    var alkhar =
      this.TotalOutstandingBalance +
      this.TotalOutstandingBalance * this.calProfitADIB * this.calTenure;
    this.mPaymentADIB = alkhar / (this.calTenure * 12);
    this.monthlyDiff = this.TotalCurrentMonthlyPayment - this.mPaymentADIB;
    let vmPaymentDiff =
      this.monthlyDiff /
      ((this.TotalOutstandingBalance +
        this.TotalOutstandingBalance * this.calProfitOthers * this.calTenure) /
        (this.calTenure * 12));
    this.mPaymentDiff = Math.round(vmPaymentDiff * 100);
    let postObj = {
      ftype: strAllT,
      fbalance: strAllB,
      fmonthly: strAllM,
      mpayment: this.mPaymentADIB,
      mdiff: this.monthlyDiff,
      mpercent: this.mPaymentDiff + "%",
    };
    // postObj.ftype = strAllT;
    // postObj.fbalance = strAllB;
    // postObj.fmonthly = strAllM;
    // postObj.mpayment = mPaymentADIB;
    // postObj.mdiff = monthlyDiff;
    // postObj.mpercent = mPaymentDiff + "%";

    $("#lbMonthlyPaymentWithADIB").text(this.numberWithCommas(Math.round(this.mPaymentADIB)));
    $("#HMonthlyPaymentWithADIB").text(this.numberWithCommas(Math.round(this.mPaymentADIB)));

    var differenceFormat;
    differenceFormat =
      this.numberWithCommas(Math.round(this.monthlyDiff) + " (" + this.mPaymentDiff + "%)");
    let checkLang = document.querySelector("html").getAttribute("lang");
    if (checkLang == "ar") {
      differenceFormat =
       this.numberWithCommas( Math.round(this.monthlyDiff) + " (%" + this.mPaymentDiff + ")");
    }

    $("#lbDiffrence").text(differenceFormat);

    $("#lbTotalCurrentMonthlyPayment").text(this.numberWithCommas(this.TotalCurrentMonthlyPayment));

    $("#lbFinalTotal").text(this.numberWithCommas(this.TotalOutstandingBalance));

    var ctx = $("#myChart");

    var ctx = document.getElementById("myChart");
    if (this.chartFlag != 0) {
      this.myChart.destroy();
    }
    this.chartFlag++;
    this.myChart = new Chart(ctx, {
      type: "bar",
      data: {
        labels: ["", ""],
        datasets: [
          {
            label: "",
            data: [this.TotalCurrentMonthlyPayment],
            backgroundColor: ["#FF0000"],
          },
          {
            label: "",
            data: [this.mPaymentADIB],
            backgroundColor: ["#0EA3E4"],
          },
        ],
      },
    });
  }

  removeRow(event) {
    // Retrieve the ID from the clicked element's data attribute
    const calIndex = parseInt(event.getAttribute("data-calIndex"));
    
    // Find the index of the item to remove in the calLoans array
    const indexToRemove = this.calLoans.findIndex(loan => loan.id === calIndex);
    
    if (indexToRemove !== -1) {
      // Remove the item from the array
      this.calLoans.splice(indexToRemove, 1);
      
      // Animate the removal of the row and remove it from the DOM
      $(`#row_${calIndex}`).slideUp("normal", function () {
        $(this).remove();
      });
  
      // Update the displayed count of remaining items
      $("#lbDebitCount").text(this.calLoans.length);
      
      // Hide or show elements based on the number of remaining items
      if (this.calLoans.length === 0) {
        $("#DivDebitCouts").hide();
        $("#DivResult").hide();
        this.eleDivResult.hide();
      } else {
        this.updateTotal();
      }
    }
  }
  

  handleAlKhairSettlement = () => {
    this.openContainerAction();
  };

  openContainerAction() {
    if (this.modaldiv) {
      this.modaldiv.classList.add("open");
      this.backdrop.classList.add("open");
    }
  }
}

export default DebtCalculator;
